import { useReducer } from 'react';
import { otpReducer, initialOtpState } from './OtpState';
export const useOtpReducer = () => useReducer(otpReducer, initialOtpState);
//# sourceMappingURL=OtpHook.js.map